import { ChangeDetectionStrategy, Component, OnDestroy } from "@angular/core";
import { GenericPopupComponent } from "../../generic-popup.component";
import { GlobalPopupConfig, GlobalPopupService } from "./global-popup.service";
import { Subscription } from "rxjs";

@Component({
    selector: "app-global-popup",
    imports: [GenericPopupComponent],
    templateUrl: "./global-popup.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./global-popup.component.css"
})
export class GlobalPopupComponent implements OnDestroy {
  config: GlobalPopupConfig | null = null;
  popupSubscription: Subscription;
  constructor(private popupService: GlobalPopupService) {
    this.popupSubscription = this.popupService.popup$.subscribe((config) => {
      this.config = config;
    });
  }
  ngOnDestroy(): void {
    if (this.popupSubscription) {
      this.popupSubscription.unsubscribe();
    }
  }

  // Fires for every dismissal, including a button click that already closed the popup
  // itself. That double-notifies config.onClose, which is safe by design: callers use
  // it as a fallback for dismissal without a button (outside click, Escape, close icon).
  onHiding(): void {
    this.config?.onClose?.();
  }
}
